/**
 * Import third-party libraries.
 */
import styled from 'styled-components';

/**
 * Import custom style properties.
 */
import { COLORS } from '../styles';

/**
 * Table styles
 */
export const TableContainer = styled.table`
  background: transparent;
  width: 100%;
  border-top: 2px solid ${COLORS.neutral_200};
  border-bottom: 2px solid ${COLORS.neutral_200};
`;

export const TableHeaderRowCol = styled.th`
  background-color: ${COLORS.neutral_20};
  color: ${COLORS.neutral_600};
  border-bottom: 1px solid ${COLORS.neutral_200};
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  padding: 16px 19px 16px 16px;

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;

    svg {
      cursor: pointer;
    }
  }
`;

export const TableColumnHeaderCol = styled.th`
  background-color: ${COLORS.white};
  border-top: 1px solid ${COLORS.neutral_300};
  color: ${COLORS.neutral_600};
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  padding: 18px 16px;
  text-align: left;

  &.no-border {
    border: none;
  }

  &.sortable {
    cursor: pointer;

    > svg {
      float: right;
    }

    &:hover {
      background: ${COLORS.primary_20};
    }
  
    &:focus {
      background: ${COLORS.primary_100};
    }
  }
`;

export const TableDataRow = styled.tr`
  background-color: ${COLORS.neutral_100};

  &:nth-child(2n) {
    background-color: ${COLORS.neutral_20};
  }

  &:hover {
    cursor: pointer;
    background-color: ${COLORS.primary_200};
  }

  &.no-rows:hover {
    cursor: default;
    background-color: ${COLORS.neutral_100};
  }
`;

export const TableDataCol = styled.td`
  background: transparent;
  color: ${COLORS.black};
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  padding: 15px 16px;
  border: none;

  button {
    color: ${COLORS.primary_600};
    text-decoration: none;

    &:hover {
      color: ${COLORS.primary_700};
      text-decoration: underline;
    }

    &:focus {
      text-decoration: underline;
      outline: none;
      box-shadow: 0px 4px 12px ${COLORS.focus_25}, 0px 0px 8px ${COLORS.focus} !important;
      color: ${COLORS.primary_700};
    }
  }

  &.center {
    text-align: center;
  }
`;

export const TableFooterCol = styled.td`
  border-top: 1px solid ${COLORS.neutral_200};
  padding: 3.5px 20px 3.5px 16px;

  > div {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    > div > div:first-of-type {
      color: ${COLORS.black};
      font-family: Lato;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      display: block;
      padding-top: 11px;
      padding-left: 2px;
      padding-right: 30px;
    }

    span {
      color: ${COLORS.black};
      font-family: Lato;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;

      &.current-page-info {
        margin-right: 34px;
        margin-left: 39px;
      }
    }

    .controls {
      display: flex;
      justify-content: space-between;
    }
  }
`;
